import { useEffect, useState } from 'react';

const KEYBOARD_MIN_PX = 150;

/** True while the on-screen keyboard is (very likely) up: the visual viewport
 *  is much shorter than the layout viewport. False where unsupported. */
export function useKeyboardOpen(): boolean {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const vv = window.visualViewport;
    if (!vv) return;
    // A pinch-zoom also shrinks the visual viewport below the layout viewport —
    // scale > 1 means that's what happened, not a keyboard, so gate on scale
    // as well or a zoomed-in teacher would have the tab bar hidden under them.
    const onResize = () => setOpen(vv.scale <= 1 && window.innerHeight - vv.height > KEYBOARD_MIN_PX);
    vv.addEventListener('resize', onResize);
    onResize();
    return () => vv.removeEventListener('resize', onResize);
  }, []);
  return open;
}
